<!-- @for (excerpt of content; track excerpt) { -->
  <div class="excerpt" oncopy="return false" [innerHTML]="content | safeHtml"></div>
<!-- } -->
